import * as types from "./action-types";
import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '../../index';
import { IEmailFamily, IEmailType, IEmailExcelId, IEmailFamilyListResponse, IBaseResponse } from "../../../models/index";

export interface IEmailFamilyResponse {
    data: {
        success: boolean,
        message: string,
        results: IEmailFamily
    }
}

export interface IEmailTypeResponse {
    data: {
        success: boolean,
        message: string,
        results: IEmailType
    }
}

export interface IEmailExcelIdResponse {
    data: {
        success: boolean,
        message: string,
        results: IEmailExcelId
    }
}

export const ActionCreators = {
    getEmailFamily: () => (dispatch: Dispatch<IApplicationState>): Promise<IEmailFamilyListResponse> => {
        var options = {
            url: __API__ + "/email-family"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IEmailFamilyListResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setEmailFamilyList(response.data.results));

            return Promise.resolve(response);
        });
    },
    addEmailFamily: (emailFamilyName: string) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailFamilyResponse> => {
        var options = {
            url: __API__ + "/email-family",
            data: { name: emailFamilyName }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IEmailFamilyResponse) => {
            if (response.data.success) {
                var emailFamily: IEmailFamily = response.data.results;
                dispatch(ActionCreators.setAddEmailFamily(emailFamily.name, emailFamily.id));
            }

            return Promise.resolve(response);
        });
    },
    deleteEmailFamily: (emailFamilyId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/email-family/" + emailFamilyId
        };

        return dispatch(AuthActionCreators.apiDelete(options)).then((response: IBaseResponse) => {
            if (response.data.success) {
                dispatch(ActionCreators.setDeleteEmailFamily(emailFamilyId));
            }

            return Promise.resolve(response);
        });
    },
    addEmailType: (emailTypeName: string, emailFamilyId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailTypeResponse> => {
        var options = {
            url: __API__ + "/email-type",
            data: {
                name: emailTypeName,
                emailFamilyId: emailFamilyId
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IEmailTypeResponse) => {
            if (response.data.success) {
                var emailType: IEmailType = response.data.results;
                dispatch(ActionCreators.setAddEmailType(emailType));
            }

            return Promise.resolve(response);
        });
    },
    deleteEmailType: (emailFamilyId: number, emailTypeId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailTypeResponse> => {
        var options = {
            url: __API__ + "/email-type/" + emailTypeId
        };

        return dispatch(AuthActionCreators.apiDelete(options)).then((response: IEmailTypeResponse) => {
            if (response.data.success) {
                var emailType: IEmailType = response.data.results;
                dispatch(ActionCreators.setDeleteEmailType(emailFamilyId, emailTypeId));
            }

            return Promise.resolve(response);
        });
    },
    addEmailExcelId: (emailExcelIdName: string, emailTypeId: number, emailFamilyId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailExcelIdResponse> => {
        var options = {
            url: __API__ + "/email-excelid",
            data: { name: emailExcelIdName, emailTypeId: emailTypeId }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IEmailExcelIdResponse) => {
            if (response.data.success) {
                var emailExcelId: IEmailExcelId = response.data.results;
                dispatch(ActionCreators.setAddEmailExcelId(emailFamilyId, emailExcelId));
            }

            return Promise.resolve(response);
        });
    },
    deleteEmailExcelId: (emailFamilyId: number, emailTypeId: number, emailExcelId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/email-excelid/" + emailExcelId
        };

        return dispatch(AuthActionCreators.apiDelete(options)).then((response: IBaseResponse) => {
            if (response.data.success) {
                dispatch(ActionCreators.setDeleteEmailExcelId(emailFamilyId, emailTypeId, emailExcelId));
            }

            return Promise.resolve(response);
        });
    },
    setEmailFamilyList: (list: IEmailFamily[]) => {
        return {
            type: types.SET_EMAILFAMILIES,
            list
        }
    },
    setAddEmailFamily: (emailFamilyName: string, id: number) => {
        return {
            type: types.ADD_EMAILFAMILY,
            name: emailFamilyName,
            id: id
        }
    },
    setDeleteEmailFamily: (emailFamilyId: number) => {
        return {
            type: types.DELETE_EMAILFAMILY,
            emailFamilyId
        };
    },
    setAddEmailType: (emailType: IEmailType) => {
        return {
            type: types.ADD_EMAILTYPE,
            emailType
        };
    },
    setDeleteEmailType: (emailFamilyId: number, emailTypeId: number) => {
        return {
            type: types.DELETE_EMAILTYPE,
            emailFamilyId,
            emailTypeId
        };
    },
    setAddEmailExcelId: (emailFamilyId: number, emailExcelId: IEmailExcelId) => {
        return {
            type: types.ADD_EMAILEXCELID,
            emailFamilyId,
            emailExcelId
        }
    },
    setDeleteEmailExcelId: (emailFamilyId: number, emailTypeId: number, emailExcelId: number) => {
        return {
            type: types.DELETE_EMAILEXCELID,
            emailFamilyId,
            emailTypeId,
            emailExcelId
        }
    }
}